export default __webpack_public_path__ + "static/media/volume-full.a05d3aa4.svg";